<template>
  <div class="game" @click="selectGame">
    <img class="cover-image" :src="game.coverImage" :alt="game.name" />
    <div class="underline"></div>
    <div
      v-if="getUser"
      class="favorite"
      :class="{ 'not-favorited': !game.active }"
      @click="setGameStatus"
      data-comp="favorite"
    ></div>
    <div class="game-info">
      <div class="game-name">{{ game.name }}</div>
      <div class="game-counter" v-show="lessonsNum > 0">
        {{ coursesNum }} Courses - {{ lessonsNum }} Lessons
      </div>
      <div class="coach-counter" v-show="coaches > 0">
        <span class="red-dot"></span>
        {{ coaches }} Pros Coaching Now
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex"

export default {
  props: {
    game: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters("User", ["getUser"]),
    ...mapGetters("Instapro", ["instaproGames"]),
    ...mapGetters("Game", ["pgGamesMap"]),
    coaches () {
      return this.pgGamesMap[this.game.key].resource_metadata.coaching
        .num_coaches_active
    },
    coursesNum () {
      return this.game.courses.num_courses
    },
    lessonsNum () {
      return this.game.courses.num_lessons
    },
    instaproGameId () {
      for (let game of this.instaproGames) {
        if (game && game.name === this.game.key) {
          return game.id
        }
      }
      return null
    },
  },
  methods: {
    ...mapActions("User", ["setUserGameStatus", "setUserActiveGame"]),
    ...mapMutations("Util", [
      "setShowGameContainer",
      "setNavbarDrawerShowing",
      "setPageLoading",
    ]),
    ...mapActions("Task", ["loadRecommendedTasks"]),
    ...mapActions("Onboarding", ["getGameSpecificPersonas"]),
    ...mapActions("Coaching", ["loadRecommendedCoaches"]),
    ...mapActions("Optimizely", ["trackEvent"]),
    selectCoachListGameSelectGame () {
      const selectCoachListGameSelectGame = new CustomEvent(
        "selectCoachListGameSelectGame",
        {
          detail: {
            game: this.game.key,
          },
        }
      )
      document.dispatchEvent(selectCoachListGameSelectGame)
    },
    setGameStatus () {
      const body = {
        active: !this.game.active,
        game: this.game.key,
      }
      this.setUserGameStatus(body)
    },
    updateScrollPosition () {
      let scrollableElement = document.getElementById("pg-main-navigation-body")
      if (scrollableElement) {
        scrollableElement.scrollTop = 0
      }
    },
    async selectGame (e) {
      const component = e.target.getAttribute("data-comp")
      if (component === "favorite") {
        return
      }
      this.setPageLoading(true)
      window.localStorage.setItem("active_game", this.game.key)
      // const classList = e.target.classList
      // if (classList && classList[0] === "favorite") {
      //   return
      // }
      this.setShowGameContainer(false)
      this.setNavbarDrawerShowing(false)
      if (this.getUser) {
        await this.setUserActiveGame(this.game.key)
      }
      const path = `/dashboard/${this.game.key}`
      const currentPath = this.$route.path
      if (path !== currentPath) {
        await this.$router.push(path)
      }
      this.selectCoachListGameSelectGame()
      await this.setPageLoading(false)
      this.updateScrollPosition()
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_mixins.scss";
.game {
  margin-right: 3rem;
  margin-bottom: 3rem;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: flex-start;
  @include phone-down {
    margin-right: 1rem;
    margin-bottom: 2rem;
    width: calc(50% - 1rem);
    .favorite.not-favorited {
      opacity: 0.3 !important;
    }
  }
  &:hover {
    .cover-image {
      transform: translateY(-1rem);
      transition: all 0.2s;
    }
    .favorite.not-favorited {
      opacity: 0.3;
    }
    .underline {
      width: 100%;
    }
  }
  .cover-image {
    height: 30rem;
    width: 22rem;
    max-width: 100%;
    @include phone-down {
      height: 24rem;
    }
    @include phone-small {
      height: 20rem;
    }
  }
  .underline {
    height: 2px;
    width: 0;
    background: #fff;
    transition: all 0.2s;
  }
  .game-info {
    width: 100%;
    .game-name {
      font-weight: 900;
      font-size: 1.5rem;
      color: #fff;
      font-family: Proxima Nova;
      margin-top: 1rem;
    }
    .game-counter {
      font-family: Proxima Nova;
      font-size: 1.4rem;
      font-weight: 600;
      color: #fff;
      opacity: 0.6;
    }
    .coach-counter {
      display: flex;
      align-items: center;
      font-family: Proxima Nova;
      font-size: 1.4rem;
      font-weight: 600;
      color: #fff;
      opacity: 0.6;
      .red-dot {
        width: 1rem;
        height: 1rem;
        background: #ff0431;
        border-radius: 50%;
        margin-right: 1rem;
      }
    }
  }
  .favorite {
    position: absolute;
    right: 1.3rem;
    top: 1.3rem;
    width: 3.2rem;
    height: 3.2rem;
    opacity: 0.7;
    transition: all 0.2s;
    background: url("../../../assets/images/navbar/favorite.png") center
      center/cover;
    &:hover {
      background-image: url("../../../assets/images/navbar/favorite_cancel.png");
      transform: scale(1.2);
      opacity: 1;
    }
    &.not-favorited {
      opacity: 0;
      &:hover {
        background-image: url("../../../assets/images/navbar/favorite.png");
        opacity: 1;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navigation/game/Game.vue